import { render } from "./CardStyleRadius.vue?vue&type=template&id=2cd6e3d8&ts=true"
import script from "./CardStyleRadius.vue?vue&type=script&lang=ts"
export * from "./CardStyleRadius.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__